module.exports = __webpack_public_path__ + "img/Honig-aus-2021-740.149578cd.jpg";